import Vue from 'vue';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'Details',
  mixins: [validationMixin],
  components: {
    datetime: Datetime,
    DateTime,
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,

      complainTypes: [],
      complainType: { text: '', value: '' },
      serviceTypes: [],
      serviceType: { text: '', value: '' },
      outcomes: [],
      outcome: { text: '', value: '' },
      reasons: [],
      reason: { text: '', value: '' },
      groupCodes: [],
      groupCode: { text: '', value: '' },

      fromDt: '',
      toDt: '',

      stations: [],
      station: { text: '', value: '' },
      substations: [],
      substation: { text: '', value: '' },

      element: {
        TypeId: 0,
        Id: 0,
        Name: '',
        ExternalRef: ''
      },

      currentPage: 'details',
      message: '',
    }
  },
  validations: {
    complainTypeValue: {
      required
    },
    serviceTypeValue: {
      required
    },
    outcomeValue: {
      required
    },
  },
  watch: {
    reason: function (value) {
      if (!value)
        return;
      this.dataObj.appData.reasonId = value.value;
    },
    groupCode: function (value) {
      if (!value)
        return;
      this.dataObj.appData.groupCodeId = value.value;
    },
    station: function (value) {
      if (!value)
        return;
      this.dataObj.appData.stationId = value.value;
    },
    substation: function (value) {
      if (!value)
        return;
      this.dataObj.appData.substationId = value.value;
    },
    fromDt: function (val) {
      var now = new Date();

      if (!this.dataObj.appData.settings.allowFutureFromDt && val > now) {
        this.$alertMsg(this.$t('messages.MesssageFromDateFuture'));
        return;
      }
      var valM = moment(val);
      var toDtM = moment(this.dataObj.appData.toDt);
      if (!this.dataObj.appData.settings.allowFromDtToBeMoreThanToDt && valM.isAfter(toDtM)) {
        this.$alertMsg(this.$t('messages.MesssageFromDateGreaterThanToDate'));
        return;
      }
      this.dataObj.appData.fromDt = moment(val).format();
      this.calculateActualJobDuration();
    },
    toDt: function (val) {
      var now = new Date();

      if (!this.dataObj.appData.settings.allowFutureFromDt && this.dataObj.appData.fromDt > now) {
        this.$alertMsg(this.$t('messages.MesssageFromDateFuture'));
      }
      var valM = moment(val);
      var fromDtM = moment(this.dataObj.appData.fromDt);
      if (!this.dataObj.appData.settings.allowFromDtToBeMoreThanToDt && fromDtM.isAfter(valM)) {
        this.$alertMsg(this.$t('messages.MesssageFromDateGreaterThanToDate'));
      }
      this.dataObj.appData.toDt = moment(val).format();
      this.calculateActualJobDuration();
    },
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('om_investigation_updated', this.init);
    this.init();
    setTimeout(() => {
      this.$watch('complainType', this.complainTypeWatcher);
      this.$watch('serviceType', this.serviceTypeWatcher);
    }, 1000);
  },
  methods: {
    calculateActualJobDuration() {
      var startTime = new Date(this.fromDt);
      var endTime = new Date(this.toDt);
      var difference = endTime.getTime() - startTime.getTime();
      var minutes = Math.round(difference / 60000);
      this.dataObj.appData.actualJobDuration = !minutes ? 0 : minutes;

      if (this.dataObj.appData.actualJobDuration < 0) {
        this.$alertMsg(this.$t('messages.endDateBeforeStartDate'));
        this.toDt = this.fromDt;
      }
    },
    complainTypeWatcher: function (value) {
      if (!value)
        return;
      this.dataObj.appData.complainTypeId = value.value;
      if (this.dataObj.appData.employeeServiceTypeId && this.dataObj.appData.employeeServiceTypeId > 0)
        return;
      var serviceTypeId;
      if (this.dataObj.appData.complainTypeToServiceType) {
        serviceTypeId = this.dataObj.appData.complainTypeToServiceType[value.value];
        if (serviceTypeId) {
          const newServiceType = this.serviceTypes.filter(p => p.value === serviceTypeId) && this.serviceTypes.filter(p => p.value === serviceTypeId).length > 0 ? this.serviceTypes.filter(p => p.value === serviceTypeId)[0] : null;
          if (newServiceType)
            this.serviceType = newServiceType;
        }
      }
    },
    serviceTypeWatcher: function (value) {
      if (!value || value.value === '')
        return;
      this.dataObj.appData.serviceTypeId = value.value;
      if (this.dataObj.appData.serviceTypeToStation && this.dataObj.appData.isStationByServiceType === true) {
        var stationId = this.dataObj.appData.serviceTypeToStation[value.value];
        if (stationId) {
          const newStation = this.stations.filter(p => p.value === stationId.toString()) && this.stations.filter(p => p.value === stationId.toString()).length > 0 ? this.stations.filter(p => p.value === stationId.toString())[0] : null;
          this.station = newStation ? newStation : { text: '', value: '' };
        }
        else
          this.station = { text: '', value: '' };
      }
    },
    init() {
      Vue.nextTick(() => {

        this.complainTypes = this.dataObj.appData.complainTypes;
        if (this.complainTypes && this.complainTypes.length > 0)
          this.complainType = this.complainTypes.filter(p => p.value == this.dataObj.appData.complainTypeId)[0];
        this.serviceTypes = this.dataObj.appData.serviceTypes;
        if (this.serviceTypes && this.serviceTypes.length > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.serviceTypeId)[0];
        this.outcomes = this.dataObj.appData.outcomes;
        if (this.outcomes && this.outcomes.length > 0)
          this.outcome = this.outcomes.filter(p => p.value == this.dataObj.appData.outcomeId)[0];
        this.dataObj.appData.OnlySave = this.dataObj.appData.outcomeId === 0;
        this.reasons = this.dataObj.appData.reasons;
        if (this.reasons && this.reasons.length > 0)
          this.reason = this.reasons.filter(p => p.value == this.dataObj.appData.reasonId)[0];
        this.groupCodes = this.dataObj.appData.groupCodes;
        if (this.groupCodes && this.groupCodes.length > 0)
          this.groupCode = this.groupCodes.filter(p => p.value == this.dataObj.appData.groupCodeId)[0];

        this.fromDt = this.dataObj.appData.fromDt;
        this.toDt = this.dataObj.appData.toDt;
        this.appId = this.dataObj.appId;

        this.stations = this.dataObj.appData.stations;
        if (this.stations && this.stations.length > 0)
          this.station = this.stations.filter(p => p.value == this.dataObj.appData.stationId)[0];
        this.substations = this.dataObj.appData.substations;
        if (this.substations && this.substations.length > 0)
          this.substation = this.substations.filter(p => p.value == this.dataObj.appData.substationId)[0];

        if (this.dataObj.appData.employeeServiceTypeId && this.dataObj.appData.employeeServiceTypeId > 0)
          this.serviceType = this.serviceTypes.filter(p => p.value == this.dataObj.appData.employeeServiceTypeId)[0];

        if (this.serviceType && this.serviceType.value > -1) {
          this.complainTypes = this.dataObj.appData.complainTypes.filter(p => p.group.id === this.serviceType.value);
        }
      });
    },
    onTimeChanged(val) {
      this[val.var] = val.time;
    },
    setSelectedComplainType(code) {
      console.log(code);
    },
    setSelectedSTypes(code) {
      console.log(code);
    },
    setSelectedOutcome(code) {
      console.log(code);
    },
    setSelectedReason(code) {
      console.log(code);
    },
    setSelectedGroupCode(code) {
      console.log(code);
    },
    setSelectedStation(code) {
      console.log(code);
    },
    setSelectedSubstation(code) {
      console.log(code);
    },
  },

}

